@if (modal.visible()) {
<div class="modal-overlay" (click)="onOverlayClick()" [attr.data-testid]="tid('overlay')">
  <div class="modal-box" (click)="onModalClick($event)" role="dialog" aria-modal="true" [attr.data-testid]="tid('box-' + modal.type())">

    <!-- Icono segun tipo -->
    <div class="modal-icon" aria-hidden="true" [class.success]="modal.type() === 'success'" [class.error]="modal.type() === 'error'" [class.warning]="modal.type() === 'warning' || modal.type() === 'confirm'" [class.prompt]="modal.type() === 'prompt'">
      @if (modal.type() === 'success') {
        <!-- Mismo asset que se usa en pantallas de éxito del onboarding. -->
        <img src="assets/img/icon_check.svg" alt="" />
      } @else if (modal.type() === 'error') {
        <svg viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="2"/>
          <path d="M8 8l8 8M16 8l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      } @else if (modal.type() === 'prompt') {
        <!-- Mismo asset que se usa en la confirmación de T&C del onboarding. -->
        <img src="assets/img/adver.svg" alt="" />
      } @else {
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M12 2L1.5 21h21L12 2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
          <path d="M12 9v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <circle cx="12" cy="17.5" r="1" fill="currentColor"/>
        </svg>
      }
    </div>

    <!-- Titulo opcional -->
    @if (modal.title()) {
      <h3 class="modal-title" [attr.data-testid]="tid('title')">{{ modal.title() }}</h3>
    }

    <!-- Texto -->
    <p class="modal-text" [attr.data-testid]="tid('text')">{{ modal.text() }}</p>

    <!-- Textarea (sólo en modo prompt). Sin two-way binding para evitar
         depender de FormsModule; el valor se sincroniza por evento. -->
    @if (modal.isPrompt()) {
      <div class="modal-prompt">
        @if (modal.promptLabel()) {
          <label class="modal-prompt-label">{{ modal.promptLabel() }}</label>
        }
        <textarea
          class="modal-prompt-input"
          rows="4"
          [placeholder]="modal.promptPlaceholder()"
          [attr.maxlength]="modal.promptMaxLength()"
          [value]="modal.promptValue()"
          (input)="onPromptInput($event)"
          [attr.data-testid]="tid('input-prompt')"
          [attr.aria-label]="modal.promptLabel() || modal.promptPlaceholder()"
        ></textarea>
        @if (modal.promptMaxLength()) {
          <span class="modal-prompt-counter" [attr.data-testid]="tid('counter')">{{ modal.promptValue().length }} / {{ modal.promptMaxLength() }}</span>
        }
      </div>
    }

    <!-- Botones -->
    @if (modal.isConfirm() || modal.isPrompt()) {
      <div class="modal-actions">
        <button type="button" class="modal-button modal-button--cancel" (click)="onCancelClick()" [attr.data-testid]="tid('button-cancel')">
          {{ modal.cancelLabel() }}
        </button>
        <button type="button" class="modal-button" (click)="onButtonClick()" [attr.data-testid]="tid('button-confirm')">
          {{ modal.buttonLabel() }}
        </button>
      </div>
    } @else {
      <button type="button" class="modal-button" (click)="onButtonClick()" [attr.data-testid]="tid('button-accept')">
        {{ modal.buttonLabel() }}
      </button>
    }

  </div>
</div>
}
